// extracted by mini-css-extract-plugin
export default {"main":"Experiences_main__HHjG7","list":"Experiences_list__W7-q9"};